import { format } from "date-fns";

export type ScheduleMode = "single" | "range" | "count";

export interface SessionSchedule {
  mode: ScheduleMode;
  endDate?: Date;
  weekdays: number[]; // 0=Sun … 6=Sat
  count?: number;
}

export const WEEKDAYS_MON_FRI = [1, 2, 3, 4, 5];
export const DEFAULT_SCHEDULE: SessionSchedule = { mode: "single", weekdays: WEEKDAYS_MON_FRI };

/** Counts sessions between start and end (inclusive) on the chosen weekdays. */
export function countSessionsInRange(start?: Date, end?: Date, weekdays: number[] = WEEKDAYS_MON_FRI): number {
  if (!start || !end || end < start || !weekdays.length) return 0;
  const d = new Date(start.getFullYear(), start.getMonth(), start.getDate());
  const last = new Date(end.getFullYear(), end.getMonth(), end.getDate());
  let n = 0;
  while (d <= last) {
    if (weekdays.includes(d.getDay())) n++;
    d.setDate(d.getDate() + 1);
  }
  return n;
}

export function resolveSessionCount(s: SessionSchedule, start?: Date): number | null {
  if (s.mode === "range") return countSessionsInRange(start, s.endDate, s.weekdays) || null;
  if (s.mode === "count") return s.count && s.count > 0 ? s.count : null;
  return null;
}

/** DB payload for itinerary_items. */
export function scheduleToPayload(s: SessionSchedule, start?: Date) {
  const count = resolveSessionCount(s, start);
  return {
    session_count: count,
    session_end_date: s.mode === "range" && s.endDate ? format(s.endDate, "yyyy-MM-dd") : null,
    session_weekdays: s.mode === "range" ? s.weekdays : null,
  };
}

export function scheduleFromItem(item: any): SessionSchedule {
  if (!item?.session_count) return { ...DEFAULT_SCHEDULE };
  if (item.session_end_date) {
    return {
      mode: "range",
      endDate: new Date(item.session_end_date),
      weekdays: item.session_weekdays?.length ? item.session_weekdays : WEEKDAYS_MON_FRI,
      count: item.session_count,
    };
  }
  return { mode: "count", weekdays: WEEKDAYS_MON_FRI, count: item.session_count };
}
